{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "https://quantumetzchaim.com/schemas/path-map-v0.3.schema.json",
  "title": "Quantum Etz Chaim path map 0.3",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "id",
    "version",
    "status",
    "label",
    "kernelCompatibility",
    "convention",
    "integrity",
    "paths"
  ],
  "properties": {
    "id": { "type": "string", "pattern": "^qec-[a-z-]+-v?[0-9]+\\.[0-9]+$" },
    "status": { "type": "string", "minLength": 1 },
    "label": { "type": "string", "minLength": 1 },
    "version": { "type": "string", "pattern": "^[0-9]+\\.[0-9]+\\.[0-9]+$" },
    "kernelCompatibility": { "const": ">=0.3.0 <0.4.0" },
    "convention": { "const": "project-defined-symbolic-architecture" },
    "integrity": {
      "type": "object",
      "additionalProperties": false,
      "required": ["algorithm", "scope", "digest"],
      "properties": {
        "algorithm": { "const": "sha256" },
        "scope": { "const": "canonical-json:paths" },
        "digest": { "type": "string", "pattern": "^[0-9a-f]{64}$" }
      }
    },
    "paths": {
      "type": "array",
      "minItems": 22,
      "maxItems": 22,
      "items": { "$ref": "#/$defs/path" }
    }
  },
  "$defs": {
    "path": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "letter",
        "letterName",
        "source",
        "destination",
        "operation",
        "transform",
        "services",
        "description"
      ],
      "properties": {
        "letter": { "type": "string", "pattern": "^[א-ת]$" },
        "letterName": { "type": "string", "minLength": 1 },
        "source": { "$ref": "#/$defs/region" },
        "destination": { "$ref": "#/$defs/region" },
        "operation": { "enum": ["hold", "exchange", "reseed"] },
        "transform": {
          "type": "object",
          "additionalProperties": false,
          "required": ["id", "version"],
          "properties": {
            "id": { "type": "string", "pattern": "^[a-z][a-z0-9-]+$" },
            "version": { "const": "0.3.0" }
          }
        },
        "services": {
          "type": "array",
          "minItems": 2,
          "maxItems": 2,
          "uniqueItems": true,
          "items": { "type": "string", "minLength": 1 }
        },
        "description": { "type": "string", "minLength": 1 }
      }
    },
    "region": {
      "enum": [
        "Keter",
        "Chokhmah",
        "Binah",
        "Daat",
        "Chesed",
        "Gevurah",
        "Tiferet",
        "Netzach",
        "Hod",
        "Yesod",
        "Malchut"
      ]
    }
  }
}
